import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOrg } from '../org/context';

/**
 * Guards the create-organization screen: once the user has at least one org there
 * is nothing to create, so redirect to the org landing (`/`). While the list is
 * empty, loading, idle, or errored, the children (the create form) are shown —
 * only a confirmed membership triggers the redirect.
 */
export function RequireNoOrg({ children }: { children: ReactNode }) {
  const { orgs } = useOrg();
  if (orgs.length > 0) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
